import styled from 'styled-components';

export const MainContainer = styled.div`
  max-width: 500px;
  width: 80%;
  height: 100%;
  min-height: 150px;
  position: relative;
  overflow: hidden;
  margin: auto;
`;

export const ExperienceIframeContainer = styled.div`
  display: block;
  position: relative;
  max-width: 800px;
  width: 100%;
  height: 0;
  padding-top: 100%;
  margin-top: 10px;
`;
ExperienceIframeContainer.displayName = ExperienceIframeContainer;

export const ExperienceIframe = styled.iframe`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;
ExperienceIframe.displayName = 'ExperienceIframe';
